import type {ReactElement} from 'react';
import {FontHeading} from '@Components/font-selector-panel/components/font-heading';
import {FontsList} from '@Components/font-selector-panel/components/fonts-list';
import type {OnSelectFontFamilyCallback} from '@Components/font-selector-panel/font-selector.types';
import type {FontData} from '@Libraries/font-library';
import { isFontSupported} from '@Libraries/font-library';
import {FontNotSupportedInformationBox} from '@Components/font-selector-panel/components/font-not-supported-information-box';
import {useAppSelector} from '@/hooks';

interface MyDesignFontSectionProps {
  className?: string;
  fontsInDesign: Array<string>;
  onSelectFontFamily?: OnSelectFontFamilyCallback;
  selectedFontFamily?: string;
}

export function MyDesignFontSection({className = '', onSelectFontFamily = (): void => {}, selectedFontFamily = '', ...props}: MyDesignFontSectionProps): ReactElement<any> {
  const allFonts = useAppSelector((state) => {
    return state.fontSelector.pmwFonts as Array<FontData> | null;
  });
  const userFonts = useAppSelector((state) => {
    return state.fontSelector.userFonts as Array<FontData> | null;
  });

  const getFontFromPMWFontsIfExists = (fontFamily: string): FontData | null => {
    if (!allFonts) {
      return null;
    }
    for (const eachFont of allFonts) {
      if (eachFont.fontFamily === fontFamily) {
        return eachFont;
      }
    }
    return null;
  };

  const getFontFromUserFontsIfExists = (fontFamily: string): FontData | null => {
    if (!userFonts) {
      return null;
    }
    for (const eachFont of userFonts) {
      if (eachFont.fontFamily === fontFamily) {
        return eachFont;
      }
    }
    return null;
  };

  const getFontsFromFontFamilies = (): Array<FontData> => {
    const fontsInDesign: Array<FontData> = [];
    for (const font of props.fontsInDesign) {
      const pmwFont = getFontFromPMWFontsIfExists(font);
      if (pmwFont) {
        fontsInDesign.push(pmwFont);
      }
      const userFont = getFontFromUserFontsIfExists(font);
      if (userFont) {
        fontsInDesign.push(userFont);
      }
    }

    return fontsInDesign;
  };

  const showNotSupportedBox = (): ReactElement<any> | null => {
    if (selectedFontFamily === '') {
      return null;
    }
    if (isFontSupported(selectedFontFamily)) {
      return null;
    }

    return <FontNotSupportedInformationBox fontFamily={selectedFontFamily} />;
  };

  return (
    <div className={className}>
      <FontHeading heading={window.i18next.t('pmwjs_on_my_design')} />
      {showNotSupportedBox()}
      <FontsList selectedFontFamily={selectedFontFamily} onSelectFontFamily={onSelectFontFamily} fontNames={getFontsFromFontFamilies()} />
    </div>
  );
}
